import {Component, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {EmailTemplateService} from "../../services/email-template.service";
import {EmailTemplate} from "../../model/EmailTemplate";
import {EmailTemplateContent} from "../../model/EmailTemplateContent";
import {SettingsService} from "../../services/settings.service";
import {Setting} from "../../model/Setting";

@Component({
    selector: 'app-email-template-modal',
    templateUrl: './email-template-modal.component.html',
    styleUrls: ['./email-template-modal.component.scss'],
})
export class EmailTemplateModalComponent implements OnInit {

    public templates: EmailTemplate[] = [];
    public selectedTemplate: EmailTemplate;
    public adminEmailSetting = new Setting();


    constructor(
        private emailTemplateService: EmailTemplateService,
        private settingService: SettingsService,
    ) {
    }

    ngOnInit() {
    }

    ionViewWillEnter() {
        this.loadTemplates();
        this.loadSettings();
    }

    private loadSettings() {
        this.adminEmailSetting.key = this.settingService.ADMIN_EMAIL;
        this.settingService.getIsoNumberSetting(this.adminEmailSetting).toPromise()
            .catch(err => {
                console.log(err);
                if(err != undefined && err.status == 404){
                    this.settingService.createIsoNumberSetting(this.adminEmailSetting).toPromise()
                        .catch(err => {
                            console.log(err);
                        })
                        .then(re => {
                            if(re != undefined && re.status == 200){
                                this.adminEmailSetting = re.body;
                            }
                        });
                }
            })
            .then(res => {
                if(res != undefined && res.status == 200){
                    this.adminEmailSetting = res.body;
                }
            });
    }

    public updateSetting() {
        this.settingService.updateIsoNumberSetting(this.adminEmailSetting).toPromise()
            .catch(err => {
                console.log(err);
            })
            .then(res => {
                if(res != undefined && res.status == 200){
                    this.adminEmailSetting = res.body;
                }
            });
    }

    private loadTemplates(): void {
        this.emailTemplateService.getAll().toPromise().then(res => {
            this.templates = res.body;
        });
    }

    public addTemplate(): void {
        this.selectedTemplate = new EmailTemplate();
    }

    public save(): void {
        if(this.selectedTemplate.id != undefined && this.selectedTemplate.id != undefined && this.selectedTemplate.id > 0) {
            this.emailTemplateService.update(this.selectedTemplate).toPromise().then(() => this.loadTemplates());
        }else{
            this.emailTemplateService.create(this.selectedTemplate).toPromise().then(() => this.loadTemplates());
        }
    }

    public addContent(): void {
        this.selectedTemplate.contents.push(new EmailTemplateContent());
    }

}
